<template>
    <div class="m-basket">
        <div class="m-user"><user-info/></div>

        <div class="basket-view">
            <div class="header"></div>

            <div class="basket-pannel" v-if="basket_list && JSON.stringify(basket_list) != '{}'">
                <div class="group-item" v-for="(list,key) in basket_list" :key="'s-' + key">
                    <div class="group-pannel">
                        <div class="pannel-body"></div>
                        <div class="pannel-content" >

                            <div class="shop-name">
                                
                                <div class="check-box shop-all" :class="{'act' : pick_list[key]}" @click="shopPickAll(list,key)"></div>
                                <div class="name">
                                    <p>{{ shop_dic[key].name }}</p>
                                    <div class="discount-info">{{ shop_dic[key].discount }}</div>
                                </div>
                            </div>

                            <div class="u-btn shop" @click="see_offer(key);"></div>

                            <ul class="item-list">
                                <li v-for="(item,index) in list" :key="index">

                                    <div class="check-box"
                                    @click="basketPick(item,key);"
                                    :class="{'act': item.isChecked || pick_list[key] }"></div>

                                    <div class="item-detail">
                                        <div class="goods-detail">
                                            <div class="goods-wrapper">
                                                <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                            </div>  
                                        </div>                                
                                        
                                        <div class="price-info">
                                            <h6 class="item-name">{{ item.giftName }}</h6>
                                            <div class="low">最低价<em class="icon-m3b"></em><span>{{ item.minPrice }}</span><span class="p-before">{{ item.maxPrice }}</span></div>
                                            <div class="now">当前价<em class="icon-m3b"></em><span>{{ item.price }}</span></div>                                           
                                        </div>
                                    </div>

                                    <div class="u-btn apply" :class="{'disabled' : item.price == item.minPrice}" @click="call_cut(item)"></div>
                                </li>
                            </ul>
                        </div>
                    </div>                    
                </div>
            </div>
            <div class="basket-pannel" v-else>
                <div class="notice">
                    <h5>您还没有相关订单</h5>
                    <p><router-link to="/"> 可以去集市看看有没有想买的~</router-link></p>                
                </div>                
            </div>

            <!-- todo rec -->
            <rec-view :shop_view="true"></rec-view>

            <!-- calculator -->
            <!-- <calculator @basketPickAll="basketPickAll" @call_buyModal="call_buyModal" :basket_list="basket_list"></calculator> -->
            <div class="basket-cntor" :class="{'ios' : $global.isIos , 'kd' : KD.isApp()}" v-if="basket_list && JSON.stringify(basket_list) != '{}'">
                <div class="cntor-wrapper">
                    <div class="total">
                        <div class="check-box" 
                        @click="all_pick = !all_pick;basketPickAll(all_pick);"
                        :class ="{'act' : all_pick }"
                        ></div>
                        <p>全选</p>
                    </div>

                    <div class="cost-info">
                        <div>合计 <em class="icon-m3b"></em> <span class="cost">{{ sum.now - sum.cut - sum.offer}}</span></div>
                        <p>优惠已减<span class="discount">{{ sum.total - sum.now + sum.cut + sum.offer}}</span><em class="u-btn sale-detail" @click="callSaleModal();">优惠明细</em></p>
                    </div>

                    <div class="u-btn primary" @click="call_buyModal();"></div>
                </div>  
            </div>

        </div>
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
import shop_group from '@/components/shopgroup.js'

export default {
    data (){
        return {
            shop_info : shop_group,
            shop_dic : shop_group.shop_dic,
            basket_list : {},
            pick_list : {},
            rec_list : [],
            shop_ticket : {},
            all_pick : false,
            sum : {
                total : 0,
                now : 0,
                cut : 0,
                offer : 0,
                rate : 0,
                offer_detail : {},
            },
            ticket : false, 
            KD,          
        }
    },
    mounted (){
        this.basket_init();
        
    },
    computed :{
        _basket (){
            return this.$store.state.basket;
        },        
    },     
    watch : {
        sum :{
            handler(val, oldVal){
                //console.log(val);
                
            },
            deep:true //true 深度监听
        },
        _basket : {
            handler(newVal, oldVal) {

                this.shop_pick_init();
                this.basket_list = this.$store.state.basket;
                this.list_handler();
                
                this.ticket = this.$store.state.ticket.filter( (ele) => {
                    return ele.state == 1;
                }).length > 0;                  
            },
            deep: true
        },                 
    },       
    methods : {
        render (){
            this.$get(ajax_url_map.basket_list,{
                success : (data) => {
                    this.basket_list = data.data.data;
                    this.$store.commit("$_setBasket", this.basket_list);

                    this.list_handler();
                }
            })
        },
        basket_init (){
            this.shop_pick_init();
            this.render();
            
            this.ticket = this.$store.state.ticket.filter( (ele) => {
                return ele.state == 1;
            }).length > 0; 
        },
        list_handler(){
            for(let key in this.basket_list){
                this.basket_list[key].forEach(element => {
                    //element.isChecked = false;
                    element = {...element, isChecked: false , offer : 0,}
                });                        
            }           
        },
        shop_pick_init(){
            let vm = this;
            
            for(let key in vm.shop_dic){
                vm.pick_list[key] = false;
            }
        },
        call_cut(item){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            let player_list = item.cutUname ? [{ name :  item.cutUname, discount : (item.maxPrice - item.price)}] : [];

            if(item.cutUname)return this.$cutDetail_modal({ shareTxt : '' , player_list : player_list });

            this.$post(ajax_url_map.add_basket,{
                success : (data) => {
                    //let shareTxt = data.data.koudai + this.$store.state.userinfo.nickName + '阿斗测试分享' + data.data.shopName + data.data.price + ' ' + data.data.url;
                    let shareTxt = this.$global.share_format({...data.data,nickName : this.$store.state.userinfo.nickName});
                    this.$cutDetail_modal({ shareTxt : shareTxt , player_list : player_list });
                    //this.get_goods_list(this.sid);
                },
                error : (data) => {
                    this.$toast(data.message);
                }                
            },{
                id : item.id,
            })
        },
        list_exend (){
            let list = [];
            
            for(let key in this.basket_list){
                this.basket_list[key].forEach(element => {
                    //element.isChecked = false;
                    if(element.isChecked)list.push(element);
                });                        
            }
            
            return list;
        },
        see_offer (sid){
            this.$router.push({ name: 'detail', params: { sid: sid }});
        },
        basketPick(item,key){
            var vm = this;

            vm.$nextTick(() => {
                item.isChecked = !item.isChecked;

                var missing_flag = vm.basket_list[key].filter(function(e){
                    return !e.isChecked;
                }).length

                vm.pick_list[key] = missing_flag ? false : true;

                vm.$forceUpdate();
                vm.calculate();
                vm.status_all_check();
            })

        },
        shopPickAll(list,key){
            var vm = this;

            vm.$nextTick(() => {
                vm.pick_list[key] = !vm.pick_list[key];

                vm.basket_list[key].forEach(element => {
                    element.isChecked = vm.pick_list[key];
                });  

                vm.$forceUpdate();
                vm.calculate();
                vm.status_all_check();              
            })

        },
        basketPickAll(state){
            var vm = this;

            vm.$nextTick(() => {
                for(let key in vm.shop_dic){
                    vm.pick_list[key] = state;
                }

                for(let key in vm.basket_list){
                    vm.basket_list[key].forEach(element => {
                        element.isChecked = state;
                    });                        
                }

                vm.$forceUpdate();
                vm.calculate();             
            })
        },
        status_all_check(){
            var vm = this;
            var result = true;

            for(let key in vm.basket_list){
                vm.basket_list[key].forEach(element => {
                    //element.isChecked = state;
                    if(!element.isChecked){
                        result = false;
                    }
                });                        
            }
            
            this.all_pick = result;
        },
        calculate (){
            var vm = this;
            vm.sum = {
                total : 0,
                now : 0,
                cut : 0,
                offer : 0,
                rate : 0,
                offer_detail : {},
            }

            var temp_list = [];

            for(let shop in vm.basket_list){
                var temp_total = 0;
                var temp_offer = 0;
                var temp_now = 0;
                var temp = 0;

                vm.basket_list[shop].forEach(element => {
                    vm.sum.offer_detail[shop] = {};

                    if(element.isChecked){
                        vm.sum.total += element.maxPrice;
                        vm.sum.now += element.price;
                        temp_total += element.maxPrice;
                        temp_now += element.price;
                        temp_list.push(element)
                    }
                });
                
                //console.log(temp_list);

                //todo discount
                //todo shop discount
                //满减无限使用，折扣只用1次，目前只有1个8折
                let cutOffer = shop_group.discountType[shop];
                let rateOffer = shop_group.shopOfferType[shop];

                if(cutOffer){
                    temp_offer = cutOffer.cut * parseInt(temp_now/cutOffer.parse);
                    vm.sum.offer += parseInt(temp_offer);
                    vm.sum.offer_detail[shop].cut = parseInt(temp_offer);
                }

                if(rateOffer && this.ticket){
                    if( temp_now >= rateOffer.require){
                        //temp_offer = Math.min(rateOffer.max,Math.floor( temp_now * (10 - rateOffer.rate*10)/10 ));
                        temp_offer = Math.min(rateOffer.max,Math.ceil( temp_now * (1 - rateOffer.rate) ));
                        //todo 和后端确认是否有max
                        vm.sum.offer += parseInt(temp_offer);
                        vm.sum.rate += parseInt(temp_offer);
                        vm.sum.offer_detail[shop].rate = parseInt(temp_offer);
                    };
                }                
            }
        },        
        call_buyModal(){
            if(!this.sum.total)return this.$msg_modal('还没有选购任何商品~');

            let list = this.list_exend();

            //console.log(this.$store.state.ticket)

            this.$buy_modal({
                settle : this.sum,
                list : list,
            });              
        },
        callSaleModal(){

            if(!this.sum.total)return this.$msg_modal('还没有选购任何商品~');

            this.$sale_detail({
                settle : this.sum,
            });               
        },                
    },
}
</script>

<style lang="scss" scoped>
.m-basket{
    padding-top: 604px;
}

.m-user{
    width: 750px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);
}

.basket-view{
    width: 750px;
    // min-height: 2382px;
    padding-bottom: 200px;
    margin: 0 auto;
    background-image: url(~@/assets/images/task/bg-task.png);
    background-repeat: repeat-y;

    .header{
        width: 750px;
        height: 156px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/basket/header-basket.png);
    }

    /* notice */
    .notice{
        padding: 40px 0;
        text-align: center;

        h5{
            font-size: 40px;
            margin-bottom: 20px;
            color: #aa754f;            
        }

        a{
            color: #ad7239;
        }
    }

    .goods-detail{
        .goods-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 118px;
            height: 118px;
            background-image: url(~@/assets/images/shop/bg-item.png);
        }

        .goods-pic{
            width: 69px;
            height: 69px;
            border: 2px solid #ccae62;
        }
    }


    .u-btn.apply{
        width: 100px;
        height: 100px;
        background-image: url(~@/assets/images/basket/btn-apply.png);

        &.disabled{
            background-image: url(~@/assets/images/basket/btn-apply_disabled.png);
        }      
    }

}

.group-item{

    position: relative;
    padding-top: 30px;
    margin-bottom: 28px;

    &::before{
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 483px;
        height: 44px;
        background-image: url(~@/assets/images/basket/shop-top.png);
    }

    .group-pannel{
        position: relative;
        width: 690px;       
        margin: 0 auto;
        background: url(~@/assets/images/task/pannel-head.png) center top no-repeat,
                    url(~@/assets/images/task/pannel-footer.png) center bottom no-repeat;
        background-size: 100% auto;

        .pannel-body{
            position: absolute;
            left:0;
            top:38px;
            bottom:38px;
            width:100%;
            background: url(~@/assets/images/task/pannel-body.png) left top repeat-y;
            background-size: 100% auto;          
        }

        .pannel-content{
            position: relative;
            // min-height: 400px;
            padding: 25px 24px 22px;
            color: #7f572d;

            b{
                color: #d33d27;
            }

            span{
                color: #a0938a;

                b{
                    color: #d33d27;
                }                
            }

            ul{
                padding: 0 22px;

                li{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 14px;
                }
                
            }

            .u-btn.shop{
                position: absolute;
                right: 26px;
                top: 22px;
                width: 158px;
                height: 45px;
                background: url(~@/assets/images/basket/btn-shop.png);
            }
        }

        .check-box{
            width: 27px;
            height: 27px;
            background: url(~@/assets/images/basket/box-radio.png);

            &.act{
                background: url(~@/assets/images/basket/radio-check.png);
            }
        }

        .shop-name{
            display: flex;

            .check-box{
                margin-right: 14px;
            }

            .name p{
                font-size: 28px;
                font-weight: 700;
                color: #7f572d;
            }
        }

        .item-detail{
            display: flex;
            // justify-content: space-between;
            align-items: center;
            width: 390px;

            .price-info{
                margin-left: 20px;

                .item-name{
                    margin-bottom: 10px;
                    font-weight: 700;
                    color: #7f572d;
                    font-size: 24px;
                }

                .icon-m3b {
                    display: inline-block;
                    width: 26px;
                    height: 26px;
                    background-image: url(~@/assets/images/icon-m3b.png);
                    // vertical-align: middle;
                }

                .low {
                    color: #683d1e;
                }

                .now {
                    color: #683d1e;
                }

                .now span {
                    font-size: 28px;
                    font-weight: 700;
                    color: #d33d27;
                }

                .p-before {
                    padding-left: 8px;
                    color: #ad7239;
                    text-decoration: line-through;
                }

            }
        }

    }   
}

.basket-cntor {
    position: fixed;
    width: 750px;
    height: 112px;
    padding: 15px 15px 0 25px;
    left: 50%;
    bottom: 90px;
    background-color: #fbf9f2;
    border-radius: 20px 20px 0 0;
    z-index: 10;
    box-sizing: border-box;
    transform: translateX(-50%);

    &.ios.kd{
        bottom: 130px;
    }

}

.pc .basket-cntor{
    margin-left: -7px;
}

.cntor-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #d4a161;
}

.cntor-wrapper{
    position: relative;
}

.basket-cntor .total {
    position: relative;
    padding-left:60px;
}

.basket-cntor .check-box {
    position: absolute;
    left: 20px;
    top: 50%;
    width: 27px;
    height: 27px;
    background-image: url(~@/assets/images/icon-off.png);
    background-position: center;
    background-repeat: no-repeat;
    transform: translateY(-50%);

    &.act{
        background-image: url(~@/assets/images/icon-check-all.png);
    }
}

.basket-cntor .total p {
    display: inline-block;
}

.basket-cntor .sale-detail {
    display: inline-block;
    width: 138px;
    height: 45px;
    margin-top: -3px;
    margin-left: 20px;    
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/tag-down.png);
    vertical-align: middle;
}

.basket-cntor .u-btn.primary {
    position: relative;
    top: 5px;    
    width: 182px;
    height: 78px;
    background-image: url(~@/assets/images/btn-buy.png);
}
</style>